import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Mail, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";
import SEO from "../components/SEO";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
      toast.success("Check your email for the reset link");
    } catch {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen pt-32 pb-24 px-6 md:px-12 flex items-center justify-center" data-testid="forgot-password-page">
      <SEO title="Forgot Password" />
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        <Link to="/auth" className="inline-flex items-center gap-2 text-[#A3A3A3] hover:text-[#FFD700] transition-colors mb-8 font-mono text-sm tracking-wider" data-testid="back-to-login">
          <ArrowLeft className="w-4 h-4" />
          BACK TO LOGIN
        </Link>

        <div className="border border-white/10 p-8 md:p-12">
          <p className="font-mono text-[#FFD700] text-sm tracking-[0.3em] mb-2">ACCOUNT RECOVERY</p>
          <h1 className="font-heading text-3xl mb-6">FORGOT PASSWORD</h1>

          {sent ? (
            <div data-testid="reset-sent-message">
              <p className="text-[#C0C0C0] text-sm leading-relaxed mb-6">
                If an account exists with that email, we've sent a password reset link. Check your inbox.
              </p>
              <Link to="/auth" className="btn-primary w-full block text-center" data-testid="back-to-login-btn">
                Back to Login
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6">
              <p className="text-[#A3A3A3] text-sm mb-4">Enter your email and we'll send you a reset link.</p>
              <div className="relative flex items-center">
                <Mail className="absolute left-0 w-5 h-5 text-[#A3A3A3]" />
                <input
                  type="email"
                  placeholder="Email Address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full bg-transparent border-b-2 border-white/20 py-4 pl-10 pr-4 text-lg text-white placeholder-white/30 outline-none focus:border-[#FFD700] transition-colors"
                  required
                  data-testid="forgot-email-input"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="btn-primary w-full flex items-center justify-center gap-3"
                data-testid="send-reset-btn"
              >
                {loading ? <div className="loader w-5 h-5 border-2" /> : "Send Reset Link"}
              </button>
            </form>
          )}
        </div>
      </motion.div>
    </div>
  );
}
